import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '../../shared/guard/authentication-guard';
import { ModuleRedirectGuard } from '../../shared/guard/module-redirect-guard';
import { HasUnsavedChangesGuard } from '../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../shared/store/view/types';
import { ModuleId } from '../../shared/store/navigation/types';
import { PaymentModeComponent } from './payment-mode/payment-mode.component';

const routes: Routes = [
  {
    path: 'Finance',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, ModuleRedirectGuard],
    data: { moduleRedirect: 'finance' },
    children: [],
  },
  {
    path: 'Finance/PaymentModes',
    data: {
      breadcrumb: { label: ' ', alias: 'paymentModeList' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: PaymentModeComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.PaymentMode,
          breadcrumb: { skip: true },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinanceRoutingModule {}
